export const UNSAVED_CHANGES_BYPASS_STATE = Object.freeze({
  bypassUnsavedChangesGuard: true,
});

export const shouldBypassUnsavedChangesGuard = (location) =>
  location.state?.bypassUnsavedChangesGuard === true;
